import React, {useState, useEffect} from 'react'
import './DoubleClick.scss'

const DoubleClick = props => {

    // TODO figure out how event handling is going to work for failing - WarningToast needs to be devd and placed in component tree

    const clickWindow = props.clickWindow || 1000; //ms
    
    const [firstClick, setFirstClick] = useState(true);
    const [clickTimeout, setClickTimeout] = useState(undefined);
    const onFail = (e) => {
        alert('fail')
    }

    const onSuccess = (e) => {
        // alert('win')
        clearTimeout(clickTimeout)
        props.onGestureComplete()
    }

    const handleClick = (e) => {
        if(firstClick){
            setFirstClick(false)
        }else{
            onSuccess(e)
        }
    }

    useEffect(()=>{
        setClickTimeout(setTimeout(()=>{
            if(!firstClick) setFirstClick(true)
        }, clickWindow)) 
    }, [firstClick])

    return (
        <div className={`DoubleClick`}>
            <div className={`fail-detector`} onClick={(e) => onFail(e)}></div>
            <div className={`hotspot`}
                style={
                    props.position
                }
                onClick={(e)=>handleClick(e)}
            ></div>
        </div>
    )
}

export default DoubleClick